module.exports = __webpack_public_path__ + "d8699ae14eaa4edcb1e266fa3cd88418.png";